import {useStyles} from './ArticleStockRow.style';
import React from "react";
import ArticleStockRowProperties from "./ArticleStockRowProperties";
import clsx from "clsx";
import ShowImage from "../../../Info/ShowImage/ShowImage";

const ArticleStockRow: React.FC<ArticleStockRowProperties> = ({
                                                element,
                                                onSelect,
                                                className,
                                                selected
                                            }) => {
    const classes = useStyles();

    return (
        <div className={clsx(classes.element_row_container, className, selected && classes.active)}
             onClick={() => onSelect(element)}>
            <div className={classes.icon_info}>
                <ShowImage imageName={element.articleDefaultImage} width={70} height={70}/>
            </div>

            <div className={classes.text_container}>
                <div>{element.articleName}</div>
                <div>En inventario: {element.amount}</div>
            </div>

        </div>
    )
}


export default ArticleStockRow;